import React, { createContext, useState, useCallback } from "react";

interface DisabledButtonConfig {
  disabled: boolean;
  tooltip?: string;
}

interface SidebarContextValue {
  clickedButton: string;
  clickedButtonHandle: (button: string) => void;
  disabledButtons: Record<string, DisabledButtonConfig>;
  setButtonDisabled: (button: string, config: DisabledButtonConfig) => void;
}

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export const SidebarProvider = ({ children }) => {
  const [clickedButton, setClickedButton] = useState("");
  const [disabledButtons, setDisabledButtons] = useState<Record<string, DisabledButtonConfig>>({});

  const clickedButtonHandle = useCallback((button: string) => {
    setClickedButton(button);
    setTimeout(() => {
      setClickedButton("");
    }, 100);
  }, []);

  const setButtonDisabled = useCallback((button: string, config: DisabledButtonConfig) => {
    setDisabledButtons((prev) => ({
      ...prev,
      [button]: config,
    }));
  }, []);

  return (
    <SidebarContext.Provider
      value={{ clickedButton, clickedButtonHandle, disabledButtons, setButtonDisabled }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
